var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-originality"},[(_vm.addAdvertisingFormat.adFormat == 0)?_c('OriginalityCollection'):(_vm.addAdvertisingFormat.adFormat == 1)?_c('OriginalityVideo'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }